/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/clock': {
    width: 24,
    height: 23,
    viewBox: '0 0 24 23',
    data: `
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.799 22 22.5 17.299 22.5 11.5C22.5 5.70101 17.799 1 12 1C6.20101 1 1.5 5.70101 1.5 11.5C1.5 17.299 6.20101 22 12 22Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 11.5V7.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 11.5L16.687 16.188" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    `
  }
})
